import React from "react";
import { Input, Form, InputNumber } from "antd";
import "./TextInput.css";

export const TextInput = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    type,
    disabled,
    validation,
    addonAfter,
    tabIndex,
    onChange,
    maxLength,
    bordered,
    placeholder,
    value,
    defaultValue,
    onInput,
    style,
    minLength,
    dependencies,
    hasFeedback,
    ref,
    onBlur,
    onFocus,
  } = props;
  return (
    <FormItem
      name={name}
      label={title}
      dependencies={dependencies}
      hasFeedback={hasFeedback}
      rules={validation}
    >
      <div>
        {type === "password" ? (
          <Input.Password
            className="text-input-password"
            name={name}
            value={value}
            tabIndex={tabIndex}
            defaultValue={defaultValue}
            onChange={onChange}
            addonAfter={addonAfter}
            placeholder={placeholder}
            onInput={onInput}
            bordered={true}
            disabled={disabled}
            maxLength={maxLength}
            minLength={minLength}
            ref={ref}
            onBlur={onBlur}
            onFocus={onFocus}
          />
        ) : (
          <Input
            className="text-input-normal"
            style={style}
            name={name}
            type={type}
            value={value}
            bordered={bordered ?? true}
            placeholder={placeholder}
            addonAfter={addonAfter}
            defaultValue={defaultValue}
            tabIndex={tabIndex}
            disabled={disabled}
            maxLength={maxLength}
            minLength={minLength}
            onChange={onChange}
            onInput={onInput}
            onBlur={onBlur}
            ref={ref}
            onFocus={onFocus}
            onWheel={() => document.activeElement.blur()}
          />
        )}
      </div>
    </FormItem>
  );
};

export const NumberInput = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    minValue,
    maxValue,
    tabIndex,
    validation,
    onChange,
    placeholder,
    value,
    type,
    maxLength,
    style,
    pattern,
    disabled,
  } = props;

  return (
    <FormItem name={name} rules={validation} label={title}>
      <div>
        <Input
          type="number"
          min={minValue}
          max={maxValue}
          tabIndex={tabIndex}
          id={name}
          value={value}
          pattern={pattern}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={onChange}
          style={style}
          onKeyPress={(e) => {
            if (e.target.value.length == 4) return false;
          }}
          disabled={disabled}
        />
      </div>
    </FormItem>
  );
};

export default TextInput;
